




































import { Component, Vue, Prop } from "vue-property-decorator";
import vueCustomScrollbar from "vue-custom-scrollbar";

@Component({
  name: "PageLayout",
  components: {
    vueCustomScrollbar,
  },
})
export default class PageLayout extends Vue {
  @Prop({ default: () => "" })
  public icon!: string;

  @Prop({ default: () => "Page Title" })
  public title!: string;

  @Prop({ default: () => false })
  public hasActionsLeft!: boolean;

  @Prop({ default: () => false })
  public hasActionsRight!: boolean;

  @Prop({ default: () => false })
  public hasPageActions!: boolean;
}
